import { createTheme } from '@mui/material/styles';
import { capitalMuiTheme } from '@opengov/capital-mui-theme';
import LinkBehavior from './components/LinkBehavior';

/**
 * Extends the Capital MUI theme with React Router integration so that
 * MUI Link and ButtonBase-derived components (Button, IconButton,
 * ListItemButton, Tab, etc.) use React Router navigation automatically
 * when given an `href` prop—no need to pass `component={RouterLink}`.
 */
const theme = createTheme(capitalMuiTheme, {
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
    },
  },
});

export default theme;
